import './scss/styles.scss'

const top = 100
const navbar = document.querySelector('#topMenu')
const hamburger = document.querySelector('#switchMobileMenu')
const internalLinks = document.getElementsByClassName('internal-link')

function toggleMobileMenu() {
  navbar.classList.toggle('visible')
}

function closeMobileMenu() {
  navbar.classList.remove('visible')
}

function stickynavbar() {
  if (window.scrollY > top) {
    navbar.classList.add('sticky')
  } else {
    navbar.classList.remove('sticky')
  }
}

function addCarousel(containerId) {
  const intervalTime = 5000
  const container = document.getElementById(containerId)
  const slidesContainer = container.querySelector('.carousel')
  const slides = slidesContainer.querySelectorAll('.slide')
  const prevButton = container.querySelector('.arrow-left')
  const nextButton = container.querySelector('.arrow-right')
  const resetButton = container.querySelector('.arrow-reset')
  const slideWidth = slides[0].clientWidth
  let nextSlide = 1
  prevButton.classList.toggle('disabled')

  const prevClickHandler = () => {
    if (!prevButton.classList.contains('disabled')) {
      if (nextButton.classList.contains('disabled')) {
        nextButton.classList.toggle('disabled')
        nextButton.classList.toggle('hidden')
        resetButton.classList.toggle('hidden')
      }

      slidesContainer.scrollLeft -= slideWidth + 22
      nextSlide--

      if (nextSlide === 1) {
        prevButton.classList.toggle('disabled')
      }

      if (!autoplayInterval) {
        autoplayInterval = setInterval(intervalFunction, intervalTime)
      }
    }
  }

  const nextClickHandler = () => {
    if (!nextButton.classList.contains('disabled')) {
      if (prevButton.classList.contains('disabled')) {
        prevButton.classList.toggle('disabled')
      }

      slidesContainer.scrollLeft += slideWidth + 22
      nextSlide++

      if (nextSlide === slides.length) {
        nextButton.classList.toggle('disabled')
        nextButton.classList.toggle('hidden')
        resetButton.classList.toggle('hidden')
      }

      if (!autoplayInterval) {
        autoplayInterval = setInterval(intervalFunction, intervalTime)
      }
    }
  }

  const resetClickHandler = () => {
    slidesContainer.scrollLeft -= 2000
    nextSlide = 1
    prevButton.classList.toggle('disabled')
    nextButton.classList.toggle('disabled')
    nextButton.classList.toggle('hidden')
    resetButton.classList.toggle('hidden')

    if (!autoplayInterval) {
      autoplayInterval = setInterval(intervalFunction, intervalTime)
    }
  }

  const intervalFunction = () => {
    if (!nextButton.classList.contains('disabled')) {
      nextClickHandler()
    } else {
      resetClickHandler()
    }
  }

  let autoplayInterval = setInterval(intervalFunction, intervalTime)

  resetButton.addEventListener('click', () => {
    clearInterval(autoplayInterval)
    autoplayInterval = null

    resetClickHandler()
  })

  nextButton.addEventListener('click', () => {
    clearInterval(autoplayInterval)
    autoplayInterval = null

    nextClickHandler()
  })

  prevButton.addEventListener('click', () => {
    clearInterval(autoplayInterval)
    autoplayInterval = null

    prevClickHandler()
  })
}

window.addEventListener('scroll', stickynavbar)
hamburger.addEventListener('click', toggleMobileMenu)
for (let i = 0; i < internalLinks.length; i++) {
  internalLinks[i].addEventListener('click', closeMobileMenu, false)
}
addCarousel('slides-container-1')
addCarousel('slides-container-2')
